import React from "react";
import { Outlet, Navigate } from "react-router-dom";
import { useAuth } from "../hooks/Auth";

import { Painel } from "../pages/Painel/index";

const PrivateRoutes: React.FC = () => {
  const { user } = useAuth();

  return !!user ? (
    <Painel childComponent={<Outlet />} />
  ) : (
    <Navigate to={"/"} />
  );
};

export default PrivateRoutes;
